import {svgIconWrapper} from '../svg-icon-wrapper';

import TextifulRegular from './textiful-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <TextifulRegular {...props} />;
}

SvgComponent.iconName = 'textifulRegular';

export const TextifulRegularIcon = svgIconWrapper(SvgComponent);
